/* eslint-disable react/prop-types */
import * as React from 'react';
import { ModalStyled, ModalBackground } from "./style";
var Modal = function Modal(_ref) {
  var children = _ref.children,
    labelId = _ref.labelId;
  return /*#__PURE__*/React.createElement(ModalBackground, {
    role: "dialog",
    "aria-labelledby": labelId
  }, /*#__PURE__*/React.createElement(ModalStyled, null, children));
};
export default Modal;